<template>
  <ion-page>
    <ion-header>
      <div class="navbar">
        <img class="nav-icon" :src="getBrandImageUrl('xiaoyu.png')" alt="" @click="onClose" />
        {{ pageTitle }}
      </div>
    </ion-header>

    <ion-content>
      <div style="height: 22px"></div>
      <img class="content-img" :src="imagePath" />
    </ion-content>

    <ion-footer>
      <ion-toolbar class="ion-no-border">
        <div class="footer">
          <img class="pic" :src="getBrandImageUrl('grammar4.png')" alt="" @click="prev" />
          <div v-if="!isPrepare" class="btn1" @click="endStudy">退出</div>
          <div v-if="!isPrepare" class="btn1" @click="openGrammarKnowledge">讲解</div>
          <div v-if="!isPrepare" class="btn2" @click="openGrammarExamination">测试</div>
          <div v-if="!isPrepare" class="btn3" @click="finishedStudy">完成</div>
          <img class="pic" :src="getBrandImageUrl('grammar5.png')" alt="" @click="next" />
        </div>
      </ion-toolbar>
    </ion-footer>
  </ion-page>
</template>

<script>
import { IonPage, IonHeader, IonToolbar, IonContent, IonFooter, modalController } from "@ionic/vue"

import { checkmark, chevronBack, chevronForward } from "ionicons/icons"
import { getBrandImageUrl } from "@/js/brandImages"
import store from "@/js/store"
import GrammarKnowledge from "@/views/grammar/GrammarKnowledge"
import GrammarExamination from "@/views/grammar/GrammarExamination"

//语法资源地址
const grammarUrl = `${store.getOEMBASE()}images/grammar2/`
const noImageUrl = `${store.getOEMBASE()}images/other/no-image.gif`

export default {
  name: "GrammarPage",
  components: {
    IonPage,
    IonHeader,
    IonToolbar,
    IonContent,
    IonFooter,
  },
  props: ["courseId", "chapterId", "chapter"],

  setup() {
    return {
      checkmark,
      chevronBack,
      chevronForward,
    }
  },

  data() {
    return {
      appointment: undefined,
      imagePath: undefined,
      knowledge: undefined,
      currentPage: undefined,
      maxPage: 0,
      queryForm: {},
      dataForm: {},
      imageUrl: undefined,
      grammarList: [],
      pageTitle: undefined,
      isPrepare: sessionStorage.getItem("isPrepare"), //1：陪练备课状态
    }
  },

  mounted() {
    this.init()
    this.getGrammarPagesForStudy()
  },

  methods: {
    getBrandImageUrl,
    init() {
      this.appointment = this.store.getAppointment()
      this.imageUrl = grammarUrl + this.appointment.courseId + "/" + this.chapter + "/"
      this.resetQueryForm()
      this.resetDataForm()
    },

    resetQueryForm() {
      this.queryForm = {
        studentId: this.appointment.studentId,
        courseId: this.courseId,
        chapterId: this.chapterId,
      }
    },

    resetDataForm() {
      this.dataForm = {
        studentId: this.appointment.studentId,
        chapterId: this.chapterId,
        page: undefined,
        finished: undefined,
      }
    },

    async openGrammarKnowledge() {
      const modal = await modalController.create({
        component: GrammarKnowledge,
        componentProps: { chapterId: this.chapterId },
        cssClass: "modal_controller_class",
      })
      await modal.present()
    },

    async openGrammarExamination() {
      const modal = await modalController.create({
        component: GrammarExamination,
        componentProps: { chapterId: this.chapterId },
        cssClass: "modal_controller_class",
      })
      await modal.present()
    },

    getGrammarPagesForStudy() {
      this.ajax.post("/grammar/getGrammarPagesForStudy", this.queryForm).then((res) => {
        if (res.data.success) {
          let grammar = res.data.data
          this.pageTitle = res.data.title
          if (grammar.image) {
            this.imagePath = this.imageUrl + grammar.image
          } else {
            this.imagePath = noImageUrl
          }
          this.knowledge = grammar.knowledge
          this.currentPage = grammar.page
          this.maxPage = grammar.maxPage
          this.grammarList = []

          if (res.data.list) {
            res.data.list.forEach((v) => {
              this.grammarList[v.page] = v
            })
          }
        }
      })
    },

    prev() {
      this.currentPage = this.currentPage > 1 ? this.currentPage - 1 : this.currentPage
      let grammar = this.grammarList[this.currentPage]
      if (grammar && grammar.image) {
        this.imagePath = this.imageUrl + grammar.image
      } else {
        this.imagePath = noImageUrl
      }
      this.knowledge = grammar.knowledge
      this.audio(this.voice_path + "page.mp3")
    },

    next() {
      if (this.currentPage >= this.maxPage) {
        this.currentPage = this.maxPage
        this.alert("已经到最后一页 ")
      }

      this.currentPage = this.currentPage < this.maxPage ? this.currentPage + 1 : this.currentPage
      let grammar = this.grammarList[this.currentPage]
      if (grammar.image) {
        this.imagePath = this.imageUrl + grammar.image
      } else {
        this.imagePath = noImageUrl
      }
      this.knowledge = grammar.knowledge
      this.audio(this.voice_path + "page.mp3")
    },

    //结束本次练习
    endStudy() {
      this.dataForm.page = this.currentPage
      this.dataForm.finished = undefined
      this.ajax.post("/grammar/endGrammarStudy", this.dataForm).then((res) => {
        if (res.data.success) {
          this.onClose()
        }
      })
    },

    //完成本章节练习
    finishedStudy() {
      this.dataForm.page = this.currentPage
      this.dataForm.finished = 1
      this.ajax.post("/grammar/endGrammarStudy", this.dataForm).then((res) => {
        if (res.data.success) {
          modalController.dismiss("FINISHED")
        }
      })
    },
  },
}
</script>

<style scoped>
ion-toolbar {
  /* --background: #645fa9; */
  --padding: 0;
  --margin: 0;
  --border: none;
}

.buttons {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.bottom-button-right {
  --background: #dcdaf6;
  --border-radius: 8px 0 0 8px;
  --color: #000;
  --box-shadow: none;
}

.bottom-button-center {
  --background: #dcdaf6;
  --border-radius: 8px;
  --color: #000;
  --box-shadow: none;
}

.bottom-button-center-finish {
  --background: #32cf61;
  --border-radius: 8px;
  --color: #ffffff;
  --box-shadow: none;
}

.bottom-button-center-knowledge {
  --background: #0088cf;
  --border-radius: 8px;
  --color: #ffffff;
  --box-shadow: none;
}

.bottom-button-center-examination {
  --background: #fcb1ad;
  --border-radius: 8px;
  --color: #ffffff;
  --box-shadow: none;
}

.bottom-button-left {
  --background: #dcdaf6;
  --border-radius: 0 8px 8px 0;
  --color: #000;
  --box-shadow: none;
}

.knowledge {
  line-height: 2rem;
  padding: 2vw;
  display: block;
  border: 1px dashed gray;
}

.knowledge-show {
  display: block;
}
/* new ui  */

.navbar {
  height: 44px;
  line-height: 44px;
  text-align: center;
  position: relative;
}
.nav-icon {
  width: 24px;
  height: 24px;
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translate(0, -50%);
}
ion-header::after {
  display: none;
}
ion-header {
  background: #fff;
}
ion-content {
  --background: #fff;
}
.content-img {
  width: 92vw;
  height: 100%;
  margin: 0 auto 20px;
  display: block;
}
.footer {
  padding: 0 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.pic {
  width: 20px;
  height: 20px;
}
.btn1 {
  width: 64px;
  height: 32px;
  text-align: center;
  line-height: 31px;
  border-radius: 16px;
  border: 0.5px solid #2bca9c;
  color: #2bca9c;
  font-size: 14px;
}
.btn2 {
  width: 64px;
  height: 32px;
  text-align: center;
  line-height: 31px;
  border-radius: 16px;
  border: 0.5px solid transparent;
  color: #927346;
  font-size: 14px;
  background: #efd0a6;
}
.btn3 {
  width: 64px;
  height: 32px;
  text-align: center;
  line-height: 31px;
  border-radius: 16px;
  border: 0.5px solid transparent;
  color: #fff;
  font-size: 14px;
  background: #2bca9c;
}
</style>
